<template>
  <div id="MoreGame" v-loading="loading" :class="MoreGameClass">
    <!-- 隊伍 -->
    <div class="MoreGameHeader">
      <div
        v-if="MOBILE_APP"
        class="btn-mobile-back"
        @click="$store.commit('MoreGame/closeMoreGameList')"
      >
        <img src="@/assets/img/mobile/btn_arrow_w.svg" />
      </div>
      <div class="teamName home" :title="getteamData.home">{{ getteamData.home }}</div>
      <template v-if="selectGameType === 2">
        <div class="teamVSLive">
          <div class="topBlock"> {{ teamData.TimeAct }} </div>
          <div v-if="!teamData.SetFlag" class="bottomBlock">
            {{ `${teamData.AwayScore} : ${teamData.HomeScore}` }}
          </div>
          <div v-else class="bottomBlock">
            {{ `${teamData.HomeScore} : ${teamData.AwayScore}` }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="teamVS">vs</div>
      </template>
      <div class="teamName away" :title="getteamData.away">{{ getteamData.away }}</div>
      <img
        class="closeBtn"
        src="@/assets/img/pc/btn_close_w.svg"
        @click="$store.commit('MoreGame/closeMoreGameList')"
      />
    </div>
    <div class="MoreGameBlock" :class="{ MoreGameBlockWithOutGameInfo: selectGameType !== 2 }">
      <div v-if="selectGameType === 2" class="GameInfoBlock" :class="{ live: gameType2Page === 2 }">
        <ul class="navList">
          <div
            v-if="MOBILE_APP"
            class="star"
            :class="starCSSJudge(teamData.EvtID)"
            @click="$store.dispatch('Setting/addFavorites', teamData.EvtID)"
          />
          <li
            class="item"
            :class="{ active: gameType2Page === 0 }"
            :title="$t('Common.LiveBoard')"
            @click="gameType2Page = 0"
          >
            <img src="@/assets/img/common/btn_VM_scoreBoard.svg" />
          </li>
          <template v-if="hasLiveVideo">
            <li v-if="isShowStandalone" class="item gray" :title="$t('Common.Live')">
              <img src="@/assets/img/common/btn_GDV_live.svg" />
            </li>
            <li
              v-else
              class="item"
              :class="{ active: gameType2Page === 2 }"
              :title="$t('Common.Live')"
              @click="showLiveVideo()"
            >
              <img src="@/assets/img/common/btn_GDV_live.svg" />
            </li>
          </template>
        </ul>
        <div v-if="gameType2Page === 0" class="gameType2Page">
          <components
            v-if="isShowLiveScore"
            :is="LiveBoardComponentName"
            :gameScoreData="gameScoreData"
            :teamData="teamData"
          />
        </div>
        <div v-else-if="gameType2Page === 2" class="gameType2Page">
          <iframe
            ref="liveVideoIframeRef"
            class="live-video-iframe"
            :class="{ max: maxVideo }"
            :src="liveVideoUrl"
          />
          <img
            v-if="maxVideo"
            class="max-close"
            src="@/assets/live/close.svg"
            :title="$t('live.close')"
            @click.stop="closeMax()"
          />
          <div v-if="!isShowStandalone" class="live-video-buttons">
            <img
              class="icon-button"
              src="~@/assets/live/standalone.svg"
              :title="$t('live.standalone')"
              @click="triggerLiveVideoStandalone()"
            />
            <img
              v-if="isSupportFullscreen"
              class="icon-button"
              src="~@/assets/live/fullscreen.svg"
              :title="$t('live.fullscreen')"
              @click="triggerLiveVideoFullscreen()"
            />
            <img
              v-else
              class="icon-button"
              src="@/assets/live/maximize.svg"
              :title="$t('live.max')"
              @click="maximizeVideo()"
            />
          </div>
        </div>
      </div>
      <div v-else class="GameInfoBlock">
        <ul class="navList">
          <div
            v-if="MOBILE_APP"
            class="star"
            :class="starCSSJudge(teamData.EvtID)"
            @click="$store.dispatch('Setting/addFavorites', teamData.EvtID)"
          />
          <li
            class="item"
            :class="{ active: gameType1Page == 1 }"
            :title="$t('Common.RollBalData')"
            @click="gameType1Page = 1"
          >
            <img src="@/assets/img/common/btn_VM_runData.svg" />
          </li>
          <li
            class="item"
            :class="{ active: gameType1Page == 3 }"
            :title="$t('Common.GameData')"
            @click="gameType1Page = 3"
          >
            <img src="@/assets/img/common/btn_VM_gameData.svg" />
          </li>
        </ul>
        <div class="coming-soon" src="@/assets/img/common/coming_soon.jpg" />
      </div>
      <!-- 盤口 -->
      <template v-if="teamData.EvtStatus === 1">
        <div class="MoreGameFilterBlock">
          <div class="leftArrowBlock">
            <i :class="collapseAllArrowIconJudge" @click="collapseAllIconClick"></i>
          </div>
          <div class="menuTabs">
            <div class="menuTab" v-for="(menuData, menuIndex) in menuTabs" :key="menuIndex">
              <div @click="selectItemKey = menuData.ItemKey">
                {{ menuData.ItemName }}
              </div>
              <div v-if="menuData.ItemKey === selectItemKey" class="active"></div>
            </div>
          </div>
          <img
            v-if="MOBILE_APP"
            class="btn-record"
            src="@/assets/img/common/btn_record.svg"
            @click="$emit('openBetRecordView')"
          />
        </div>
        <div class="MoreGameList">
          <div
            v-for="(gameData, gameIndex) in FinalGameList"
            :key="gameIndex"
            class="MoreGameListOutRow"
          >
            <div class="MoreGameListRowTitle" @click="titleClickHandler(gameData.ItemName)">
              <div class="leftArrowBlock">
                <i :class="titleArrowIconJudge(!collapseItemNames.includes(gameData.ItemName))" />
              </div>
              <div class="MoreGameListRowTitleText">
                {{ gameData.ItemName }}
              </div>
            </div>
            <template v-for="(leagueData, leagueIndex) in gameData.List">
              <template v-if="!collapseItemNames.includes(gameData.ItemName)">
                <div
                  v-for="(renderHeadData, renderHeadIndex) in leagueData.RenderHead"
                  :key="'MoreGameListInRow' + gameIndex + leagueIndex + renderHeadIndex"
                  class="MoreGameListInRow"
                >
                  <template v-if="renderHeadData.WagerTypeIDs.includes(119)">
                    <div class="wagerPlayList fix">
                      <div class="wagerPlayRow">
                        <div
                          v-for="(oddsData, oddsIndex) in renderHeadData.Odds"
                          :key="`${oddsIndex}`"
                          class="betBlock"
                          :class="isFixOddsSelected(oddsData)"
                          @click="goFixBet(oddsData, renderHeadData, teamData, leagueData, $event)"
                        >
                          <div class="betBlockTop">
                            {{ oddsData.OULineName }}
                          </div>
                          <div class="betBlockBottom">
                            {{ showFixOdds(oddsData) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="renderHeadData.WagerTypeIDs.includes(116)">
                    <div class="wagerPlayList fix">
                      <div class="wagerPlayRow t116">
                        <div
                          v-for="(oddsData, oddsIndex) in renderHeadData.Odds"
                          :key="`${oddsIndex}`"
                          class="betBlock"
                          :class="isFixOddsSelected(oddsData)"
                          @click="goFixBet(oddsData, renderHeadData, teamData, leagueData, $event)"
                        >
                          <div class="betBlockTop">
                            {{ oddsData.OULineName }}
                          </div>
                          <div class="betBlockBottom">
                            {{ showFixOdds(oddsData) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="wagerLabelBlock">
                      <!-- 單隊總分 -->
                      <template
                        v-if="
                          renderHeadData.WagerTypeIDs.includes(131) ||
                          renderHeadData.WagerTypeIDs.includes(132)
                        "
                      >
                        <template v-if="renderHeadData.HdpPos === 1">主</template>
                        <template v-else-if="renderHeadData.HdpPos === 2">客</template>
                      </template>
                      <template v-else>
                        {{ renderHeadData.HeadShowName }}
                      </template>
                    </div>
                    <div class="wagerPlayList">
                      <!-- 波膽 -->
                      <div
                        class="wagerPlayRow"
                        v-if="renderHeadData.WagerTypeIDs.indexOf(112) !== -1"
                      >
                        <div
                          v-for="(boldTemplate, boldKey) in [
                            boldTemplate1,
                            boldTemplate2,
                            boldTemplate3,
                          ]"
                          class="columnContainer"
                          :key="boldKey"
                        >
                          <div class="boldBetBlockTitle" v-if="boldKey === 0">
                            {{ $t('Common.Home') }}
                          </div>
                          <div class="boldBetBlockTitle" v-if="boldKey === 1">
                            {{ $t('Common.Drew') }}
                          </div>
                          <div class="boldBetBlockTitle" v-if="boldKey === 2">
                            {{ $t('Common.Away') }}
                          </div>

                          <div
                            class="boldBetBlock"
                            v-for="(OULine, index) in boldTemplate"
                            :class="
                              boldTableBetBlockIsSelect(
                                boldOddToMapData(renderHeadData.Odds)[OULine],
                                OULine
                              )
                            "
                            :key="`${boldKey}-${index}`"
                            @click="
                              goBoldBet(
                                boldOddToMapData(renderHeadData.Odds)[OULine],
                                teamData,
                                leagueData,
                                $event
                              )
                            "
                          >
                            <div class="boldLeft">{{ OULine }}</div>
                            <div class="boldRight">
                              {{ showDrewOdd(boldOddToMapData(renderHeadData.Odds)[OULine]) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else
                        class="wagerPlayRow"
                        v-for="(oddData, oddIndex) in renderHeadData.Odds"
                        :key="'wagerPlayRow' + gameIndex + leagueIndex + renderHeadIndex + oddIndex"
                      >
                        <div
                          class="betBlock"
                          v-for="(betData, betIndex) in $SportLib.oddDataToMorePlayData(
                            teamData.SetFlag,
                            oddData.WagerTypeID,
                            oddData
                          )"
                          :class="betBlockSelectCSS(betData.wagerPos, oddData)"
                          :key="
                            'betBlock' +
                            gameIndex +
                            leagueIndex +
                            renderHeadIndex +
                            oddIndex +
                            betIndex
                          "
                          :blockUniqueID="`MoreBet-${oddData.GameID}-${betIndex}`"
                          @click="goBet(gameData, betData, oddData, leagueData, $event)"
                        >
                          <div class="betBlockTop">
                            {{ betData.showMethod }}
                          </div>
                          <div class="betBlockBottom">
                            <Odd
                              v-if="betData.showOdd > limit"
                              :OddValue="betData.showOdd"
                              :UniqueID="`MoreBet-${oddData.GameID}-${betIndex}`"
                              :enableAni="false"
                              @oddChanged="
                                (state) =>
                                  oddChanged(state, `MoreBet-${oddData.GameID}-${betIndex}`)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </template>
          </div>
        </div>
      </template>
    </div>
    <!-- 聊天室 -->
    <div
      v-if="selectGameType === 2"
      class="GameChatBlock"
      :class="{ enable: chatEnable, extended: chatExtended }"
    >
      <GameChat ref="chat" @openPersonalPanel="openPersonalPanel()" />
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import LiveBoards from '@/components/LiveBoard/LiveBoardIndex';
  import Odd from '@/components/Odd';
  import GameChat from '@/components/GameChat';
  import { MOBILE_APP, isSupportFullscreen } from '@/config';

  export default {
    name: 'MoreGame',
    components: {
      ...LiveBoards,
      Odd,
      GameChat,
    },
    data() {
      return {
        MOBILE_APP,
        limit: 0.01,
        gameType1Page: 1,
        gameType2Page: 0,
        selectItemKey: null,
        collapseItemNames: [],
        intervalEvent: null,
        intervalEvent2: null,
        ComponentMapList: {
          1: 'Soccer',
          21: 'PingPong',
          22: 'Badminton',
          23: 'Volleyball',
          55: 'Tennis',
          82: 'Hockey',
          85: 'PCGame',
          101: 'BaseBall',
          102: 'BasketBall',
          31: 'Soccer',
        },
        boldTemplate1: ['1-0', '2-0', '2-1', '3-0', '3-1', '3-2', '4-0', '4-1', '4-2', '4-3'],
        boldTemplate2: ['0-0', '1-1', '2-2', '3-3', '4-4', 'other'],
        boldTemplate3: ['0-1', '0-2', '1-2', '0-3', '1-3', '2-3', '0-4', '1-4', '2-4', '3-4'],
        chatEnable: false,
        chatExtended: false,
        isSupportFullscreen,
        maxVideo: false,
      };
    },
    computed: {
      ...mapState('MoreGame', ['isShowStandalone']),
      liveVideoUrl() {
        const { moreGameData: more, hasLiveVideo } = this;
        if (hasLiveVideo) {
          return more.LiveLinkAry[0].slice(10);
        }
        return '';
      },
      hasLiveVideo() {
        const { moreGameData: more } = this;
        return more?.LiveLinkAry?.length;
      },
      gameStore() {
        return this.$store.state.Game;
      },
      selectGameType() {
        return this.$store.state.Game.selectGameType;
      },
      selectCatID() {
        return this.$store.state.Game.selectCatID;
      },
      CatList() {
        return this.$store.state.Game.CatList;
      },
      CatMapData() {
        return this.$store.state.Game.CatMapData;
      },
      isGameScoreRefresh() {
        const catData = this.CatMapData[this.selectCatID];
        return catData && catData.GameScoreRefresh && this.selectGameType === 2;
      },
      isQuickBetEnable() {
        return this.$store.state.Game.isQuickBet.isEnable;
      },
      betCartList() {
        return this.$store.state.BetCart.betCartList;
      },
      loading() {
        return this.$store.state.MoreGame.loading;
      },
      moreGameData() {
        if (Object.keys(this.$store.state.MoreGame.moreGameData).length === 0) {
          return null;
        } else {
          return this.$store.state.MoreGame.moreGameData;
        }
      },
      GameList() {
        if (this.moreGameData === null) {
          return [];
        }
        return this.moreGameData.List;
      },
      FinalGameList() {
        if (this.GameList.length === 0) {
          return [];
        }
        return this.GameList.filter((gameData) => {
          return gameData.ItemKeys.indexOf(this.selectItemKey) > -1;
        }).map((gameData) => {
          const newList = gameData.List.map((LeagueData) => {
            // 排列出Wager底下所有Odd
            const Odds = LeagueData.Team[0].Wager.reduce((sum, WagerData) => {
              const wagerOdds = WagerData.Odds.map((oddData) => {
                const WagerGrpID = WagerData.WagerGrpID;
                const WagerTypeID = WagerData.WagerTypeID;
                const GameTypeID = WagerData.GameType;

                const headWagerData = gameData.BestHead.find((headData) => {
                  // 如果 WagerGrpID 不是128,需要同時檢查WagerGrpIDs和WagerTypeIDs
                  if ([128].indexOf(headData.WagerGrpIDs[0]) === -1) {
                    const WagerGrpIDIndex = headData.WagerGrpIDs.indexOf(WagerGrpID);
                    const WagerTypeIDIndex = headData.WagerTypeIDs.indexOf(WagerTypeID);

                    if (WagerTypeIDIndex !== -1 && WagerGrpIDIndex !== -1) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    // 如果 WagerGrpID 是128, 只要檢查 WagerTypeIDs 就好
                    const findIndex = headData.WagerTypeIDs.findIndex(
                      (typeID) => typeID === WagerTypeID
                    );
                    if (findIndex > -1) {
                      return true;
                    } else {
                      return false;
                    }
                  }
                });

                if (headWagerData) {
                  return {
                    ...oddData,
                    WagerGrpID: WagerData.WagerGrpID,
                    WagerTypeID,
                    GameTypeID,
                    ShowName: gameData.ItemName + headWagerData.WagerTypeName,
                  };
                } else {
                  return {
                    empty: true,
                  };
                }
              });
              return [...sum, ...wagerOdds];
            }, []).filter((it) => it?.empty === undefined);

            // 組成渲染head
            let RenderHead = JSON.parse(JSON.stringify(gameData.BestHead)).map((it) => {
              return {
                ...it,
                Odds: [],
                HeadShowName: it.WagerTypeName,
              };
            });

            // 將Odd資料組進渲染head
            Odds.forEach((OddData) => {
              const oddWagerTypeID = OddData.WagerTypeID;
              RenderHead.every((renderHeadData) => {
                if (renderHeadData.HdpPos === 128) {
                  const isFind = renderHeadData.WagerTypeIDs.find((ID) => ID === oddWagerTypeID);
                  if (isFind && OddData.Status !== -1) {
                    renderHeadData.Odds.push(OddData);
                    return false;
                  }
                } else {
                  if (OddData.HdpPos === renderHeadData.HdpPos) {
                    renderHeadData.Odds.push(OddData);
                    return false;
                  }
                }
                return true;
              });
            });

            RenderHead = RenderHead.filter((renderHeadData) => renderHeadData.Odds.length !== 0);

            return {
              ...LeagueData,
              Team: LeagueData.Team[0],
              RenderHead,
            };
          });

          return {
            ...gameData,
            List: newList,
          };
        });
      },
      LiveBoardComponentName() {
        const findCatData = this.CatList.find((catData) => {
          return catData.CatID === this.selectCatID;
        });
        if (findCatData) {
          const componentName = this.ComponentMapList[this.selectCatID];
          if (componentName) {
            return componentName;
          } else {
            console.error(`${this.selectCatID} 的球種 還沒製作`);
            return null;
          }
        } else {
          console.error(`${this.selectCatID} 的球種 不在彩種列表內`);
          return null;
        }
      },
      gameScoreData() {
        if (this.isGameScoreRefresh) {
          return this.moreGameData.GameScore;
        } else {
          return this.moreGameData.GameScoreHead;
        }
      },
      isShowLiveScore() {
        return this.moreGameData?.GameScore !== undefined;
      },
      teamData() {
        return this.$store.state.MoreGame.teamData;
      },
      menuTabs() {
        if (this.moreGameData === null) {
          return [];
        }
        return this.moreGameData.Menu;
      },
      MoreGameStoreUpdateFlag() {
        return this.$store.state.MoreGame.MoreGameStoreUpdateFlag;
      },
      getteamData() {
        let home = '';
        let away = '';
        if (!this.teamData.SetFlag) {
          home = this.teamData?.AwayTeamStr;
          away = this.teamData?.HomeTeamStr;
        } else {
          home = this.teamData?.HomeTeamStr;
          away = this.teamData?.AwayTeamStr;
        }
        return {
          home,
          away,
        };
      },
      MoreGameClass() {
        if (process.env.VUE_APP_UI === 'mobile') {
          if (this.gameType2Page === 2) {
            return 'mobile mlive';
          }
          return 'mobile';
        } else if (this.selectGameType === 2 && this.gameType2Page === 2) {
          return 'live';
        } else if (this.selectGameType === 2 && this.gameType2Page === 0 && this.hasLiveVideo) {
          return 'playing';
        }
        return '';
      },
      collapseAllArrowIconJudge() {
        if (this.FinalGameList.length === this.collapseItemNames.length) {
          return 'el-icon-arrow-down';
        } else {
          return 'el-icon-arrow-up';
        }
      },
      includePrincipal() {
        return this.$store.state.Setting.UserSetting.includePrincipal;
      },
    },
    watch: {
      MoreGameStoreUpdateFlag() {
        this.resetData();
      },
      menuTabs() {
        if (this.menuTabs.length !== 0) {
          this.selectItemKey = this.menuTabs[0].ItemKey;
        }
      },
      selectItemKey() {
        this.collapseItemNames.length = 0;
        this.collapseItemNames = [];
      },
      'teamData.EvtID': {
        handler() {
          if (this.selectGameType === 2) {
            window.chat.initWebsocket(this.teamData.EvtID);
          }
        },
        immediate: true,
      },
    },
    methods: {
      ...mapMutations('MoreGame', ['showStandaloneLive']),
      triggerLiveVideoStandalone() {
        const { home, away } = this.getteamData;
        this.showStandaloneLive({ url: this.liveVideoUrl, name: `${home} vs ${away}` });
        this.gameType2Page = 0;
      },
      triggerLiveVideoFullscreen() {
        const { $refs } = this;
        const { liveVideoIframeRef } = $refs;
        if (liveVideoIframeRef) {
          liveVideoIframeRef.requestFullscreen();
        }
      },
      maximizeVideo() {
        this.maxVideo = true;
      },
      closeMax() {
        this.maxVideo = false;
      },
      showLiveVideo() {
        this.gameType2Page = 2;
        /*
        if (this.moreGameData.LiveView !== false) {
          this.gameType2Page = 2;
        } else {
          this.$notify.error({
            message: '投注100元以上可觀看24小時',
          });
        } */
      },
      boldOddToMapData(boldOdd) {
        const res = boldOdd.reduce((sum, it, index) => {
          return {
            ...sum,
            ...{
              [it.OULine]: it,
            },
          };
        }, {});
        return res;
      },
      showDrewOdd(mapData) {
        if (!mapData) return '';
        if (!mapData.DrewOdds === '') return '';
        const odds = (
          parseFloat(mapData.DrewOdds) + this.$store.getters.userOddsAdjustment
        ).toFixed(3);

        if (this.includePrincipal) {
          const value = this.$lib.trunc(parseFloat(odds) + 1);
          var arrayNum = value.toString().split('.');
          if (arrayNum.length === 1) {
            return value.toString() + '.00';
          }
          if (arrayNum.length > 1) {
            const v = arrayNum[1];
            if (v.length === 1) {
              return value.toString() + '00';
            } else if (v.length === 2) {
              return value.toString() + '0';
            }
            return value;
          }
          return value;
        } else {
          return odds;
        }
      },
      judgeGameLiveScore(templateCatID, selectCatID) {
        const findCatData = this.CatList.find((catData) => {
          return catData.CatID === templateCatID;
        });
        return findCatData.GroupCatIDs.findIndex((it) => it === selectCatID) !== -1;
      },
      resetData() {
        this.collapseItemNames.length = 0;
        this.collapseItemNames = [];
        this.selectItemKey = null;
      },
      titleArrowIconJudge(isCollapse) {
        if (!isCollapse) {
          return 'el-icon-arrow-down';
        } else {
          return 'el-icon-arrow-up';
        }
      },
      titleClickHandler(WagerGrpID) {
        const collapseIndex = this.collapseItemNames.indexOf(WagerGrpID);
        if (collapseIndex > -1) {
          this.collapseItemNames.splice(collapseIndex, 1);
        } else {
          this.collapseItemNames.push(WagerGrpID);
        }
      },
      betBlockSelectCSS(wagerPos, { GameID }) {
        const compareData = this.betCartList.find((cartData) => {
          return cartData.GameID === GameID;
        });

        if (compareData && compareData.wagerPos === wagerPos) {
          return 'betBlockSelect';
        } else {
          return '';
        }
      },
      collapseAllIconClick() {
        if (this.FinalGameList.length === this.collapseItemNames.length) {
          this.collapseItemNames.length = 0;
          this.collapseItemNames = [];
        } else {
          this.collapseItemNames.length = 0;
          this.collapseItemNames = this.FinalGameList.map((it) => it.ItemName);
        }
      },
      goBet(gameData, betData, oddData, leagueData, event) {
        if (betData.showOdd <= this.limit) {
          return;
        }

        this.$emit('AddToCart');

        const { GameTypeID } = oddData;
        const GameTypeLabel = this.$store.state.Game.GameTypeList.find(
          (it) => it.key === GameTypeID
        )?.value;

        const { WagerTypeID, WagerGrpID } = oddData;
        let ItemName = gameData.ItemName;
        // 全隊總分
        if ([131, 132].includes(WagerTypeID)) {
          if ([1, 11, 21].includes(WagerGrpID)) {
            ItemName = '上半 - ' + ItemName.split('-')[1]?.trim();
          }
        }
        // 首尾分
        else if ([117, 118].includes(WagerTypeID)) {
          const head = gameData.BestHead.find(
            (head) =>
              head.WagerGrpIDs.includes(WagerGrpID) && head.WagerTypeIDs.includes(WagerTypeID)
          );
          if (head) {
            ItemName = head.WagerTypeName;
          }
        }
        const { LiveTV = '', LiveTVLink = '' } = this.teamData;
        const data = gameData.List[0].Team;
        const betInfoData = {
          LeagueID: leagueData.LeagueID,
          HomeID: data.HomeID,
          AwayID: data.AwayID,
          TimeStr: data.ScheduleTimeStr,
          OriginShowOdd: parseFloat(betData.showOdd),
          wagerPos: betData.wagerPos,
          GameTypeID,
          GameTypeLabel: GameTypeLabel,
          GameID: oddData.GameID,
          CatID: leagueData.CatID,
          ModID: leagueData.ModID,
          CatNameStr: this.$store.state.Game.CatMapData[leagueData.CatID]?.Name,
          LeagueNameStr: leagueData.LeagueNameStr,
          HomeTeamStr: this.getteamData.home,
          AwayTeamStr: this.getteamData.away,
          WagerTypeID,
          WagerGrpID,
          EvtID: this.teamData.EvtID,
          EvtStatus: this.teamData.EvtStatus,
          SetFlag: this.teamData.SetFlag,
          ItemName,
          more: true,
          LiveTV,
          LiveTVLink,
          ...oddData,
        };

        if ([131, 132].includes(WagerTypeID)) {
          betInfoData.HomeTeamStr = data.HomeTeamStr;
          betInfoData.AwayTeamStr = data.AwayTeamStr;
        }

        this.$store.dispatch('BetCart/addCart', betInfoData);
        this.checkQuickBet(event);
      },
      starCSSJudge(EvtID) {
        if (this.$store.state.Setting.UserSetting.favorites.indexOf(EvtID) > -1) {
          return 'active';
        } else {
          return '';
        }
      },
      openLive() {
        const safariWindow = window.open();
        safariWindow.opener = null;
        this.$store.commit('setLoading', true);
        this.$store
          .dispatch('Game/GetLiveURL')
          .then((res) => {
            safariWindow.location.href = res.data;
          })
          .finally(() => {
            this.$store.commit('setLoading', false);
          });
      },
      onComingSoonClick() {
        if (this.selectGameType === 2) {
          // 滾球
          if (this.gameType2Page === 2) {
            // 直播
            this.openLive();
          }
        }
      },
      boldTableBetBlockIsSelect(oddData, OULine) {
        if (oddData === undefined) {
          return '';
        }
        const compareData = this.betCartList.find((cartData) => cartData.GameID === oddData.GameID);
        if (compareData && compareData.OULine === OULine) {
          return 'boldTableBetBlockSelect';
        } else {
          return '';
        }
      },
      checkQuickBet(event) {
        if (this.isQuickBetEnable) {
          this.$nextTick(() => {
            const clickTarget = event.target.getBoundingClientRect();
            this.$store.commit('BetCart/showQuickBetData', {
              isShow: true,
              x: clickTarget.left + clickTarget.width / 2,
              y: clickTarget.top + 22,
            });
          });
        }
      },
      goBoldBet(boldData, teamData, leagueData, event) {
        if (!boldData) {
          return;
        }

        const odds = (
          parseFloat(boldData.DrewOdds) + this.$store.getters.userOddsAdjustment
        ).toFixed(3);

        this.$emit('AddToCart');

        const { GameTypeID } = boldData;
        const GameTypeLabel = this.$store.state.Game.GameTypeList.find(
          (it) => it.key === GameTypeID
        )?.value;

        const { LiveTV = '', LiveTVLink = '' } = teamData;

        const betInfoData = {
          OriginShowOdd: parseFloat(odds),
          wagerPos: 3,
          GameTypeID,
          GameTypeLabel: GameTypeLabel,
          GameID: boldData.GameID,
          CatID: leagueData.CatID,
          CatNameStr: this.$store.state.Game.CatMapData[leagueData.CatID]?.Name,
          ModID: leagueData.ModID,
          LeagueNameStr: leagueData.LeagueNameStr,
          HomeTeamStr: teamData?.HomeTeamStr,
          AwayTeamStr: teamData?.AwayTeamStr,
          WagerGrpID: 10,
          WagerTypeID: 112,
          EvtID: teamData.EvtID,
          EvtStatus: teamData.EvtStatus,
          SetFlag: teamData.SetFlag,
          ...boldData,
          LiveTV,
          LiveTVLink,
          more: true,
        };

        this.$store.dispatch('BetCart/addCart', betInfoData);

        this.checkQuickBet(event);
      },
      isFixOddsSelected(oddsData) {
        const { GameID } = oddsData;
        const betData = this.betCartList.find((betData) => betData.GameID === GameID);
        if (betData) {
          return 'boldTableBetBlockSelect';
        } else {
          return '';
        }
      },
      showFixOdds(oddsData) {
        if (!oddsData.DrewOdds) return '';
        const odds = (
          parseFloat(oddsData.DrewOdds) + this.$store.getters.userOddsAdjustment
        ).toFixed(3);

        if (odds <= this.limit) return '';
        if (this.includePrincipal) {
          const value = this.$lib.trunc(parseFloat(odds) + 1);
          var arrayNum = value.toString().split('.');
          if (arrayNum.length === 1) {
            return value.toString() + '.00';
          }
          if (arrayNum.length > 1) {
            const v = arrayNum[1];
            if (v.length === 1) {
              return value.toString() + '00';
            } else if (v.length === 2) {
              return value.toString() + '0';
            }
            return value;
          }
          return value;
        } else {
          return odds;
        }
      },
      goFixBet(oddsData, headData, teamData, leagueData, event) {
        const { GameID, WagerGrpID, WagerTypeID, OULineName, ShowName } = oddsData;
        if (!oddsData.DrewOdds) {
          return;
        }
        const odds = (
          parseFloat(oddsData.DrewOdds) + this.$store.getters.userOddsAdjustment
        ).toFixed(3);
        if (odds <= this.limit) {
          return;
        }

        this.$emit('AddToCart');

        const { GameTypeID } = oddsData;
        const GameTypeLabel = this.gameStore.GameTypeList.find(
          (item) => item.key === GameTypeID
        )?.value;

        const { WagerTypeName } = headData;
        let ItemName = '';
        if ([119].includes(WagerTypeID) && [1, 11, 21].includes(WagerGrpID)) {
          const [WagerGrpName] = ShowName.split(' ');
          ItemName = `${WagerGrpName} ${WagerTypeName}`;
        } else {
          ItemName = `${WagerTypeName}`;
        }

        const { CatID, ModID, LeagueID, LeagueNameStr } = leagueData;
        const CatNameStr = this.gameStore.CatMapData[CatID]?.Name;
        const {
          HomeID,
          HomeTeamStr,
          AwayID,
          AwayTeamStr,
          SetFlag,
          ScheduleTimeStr: TimeStr,
          EvtID,
          EvtStatus,
          LiveTV = '',
          LiveTVLink = '',
        } = teamData;

        const betData = {
          GameTypeID,
          GameTypeLabel,
          CatID,
          CatNameStr,
          ModID,
          LeagueID,
          LeagueNameStr,
          HomeID,
          HomeTeamStr,
          AwayID,
          AwayTeamStr,
          SetFlag,
          TimeStr,
          EvtID,
          EvtStatus,
          WagerGrpID,
          WagerTypeID,
          GameID,
          OriginShowOdd: parseFloat(odds),
          wagerPos: 3,
          ItemName,
          OULineName,
          ...oddsData,
          LiveTV,
          LiveTVLink,
          more: true,
        };

        this.$store.dispatch('BetCart/addCart', betData);
        this.checkQuickBet(event);
      },

      oddChanged(state, UniqueID) {
        const el = document.querySelector(`.betBlock[blockUniqueID=${UniqueID}]`);
        if (el) {
          if (state === 1) {
            el.classList.remove('ani-value-up');
            el.classList.remove('ani-value-down');
            el.classList.add('ani-value-up');
          } else if (state === 2) {
            el.classList.remove('ani-value-up');
            el.classList.remove('ani-value-down');
            el.classList.add('ani-value-down');
          } else {
            el.classList.remove('ani-value-up');
            el.classList.remove('ani-value-down');
          }
        }
      },
      openPersonalPanel() {
        this.$emit('openPersonalPanel');
      },
    },
    created() {
      this.intervalEvent = setInterval(() => {
        this.$store.dispatch('MoreGame/GetMoreGameDetailSmall', this.teamData.EvtID);
      }, 6000);
      if (this.isGameScoreRefresh) {
        this.intervalEvent2 = setInterval(() => {
          this.$store.dispatch('MoreGame/GetGameLiveResult', this.teamData.EvtID);
        }, 5000);
      }
    },
    mounted() {
      if (this.selectGameType === 2) {
        this.$watch(
          () => {
            return this.$refs.chat.isChatEnable;
          },
          (enable) => {
            this.chatEnable = enable;
          }
        );

        this.$watch(
          () => {
            return this.$refs.chat.isExtended;
          },
          (extended) => {
            this.chatExtended = extended;
          }
        );
      }
    },
    beforeDestroy() {
      clearInterval(this.intervalEvent);
      clearInterval(this.intervalEvent2);
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/sass/theme/mixin.scss';

  #app[data-theme^='light'] {
    #MoreGame {
      background-color: #eeeeee;
      border-right: 2px solid #bbb;
      ul.navList {
        background: #666;
      }
      .MoreGameFilterBlock {
        background-color: #666;
      }
      .MoreGameListRowTitle {
        background-color: #eee;
      }
      .MoreGameListInRow {
        background-color: white;
        border-bottom: 1px solid #eeeeee;
        .MoreGameListRowTitle {
          border-bottom: 1px solid #d6d6d6;
        }
        .wagerPlayRow {
          border-bottom: 1px solid #eeeeee;
          border-left: 1px solid #eeeeee;
        }
        .betBlockTop {
          border-left: 1px solid #eeeeee;
        }
        .betBlockBottom {
          border-left: 1px solid #eeeeee;
        }
      }
      .betBlock {
        &:hover {
          background-color: #ffe1ae;
        }
      }
      .betBlockSelect {
        background-color: #ffd5d5;
      }
      .boldTableBetBlockSelect {
        background-color: #ffd5d5;
      }
      .menuTab {
        .active {
          background-color: #caffed;
        }
      }
    }
  }

  #app[data-theme^='dark'] {
    #MoreGame {
      background-color: #585858;
      border-right: 2px solid #222;
      ul.navList {
        background: #222;
      }
      .MoreGameFilterBlock {
        background-color: #404040;
      }
      .MoreGameHeader {
        background-color: #333;
        border-bottom-color: #333;
      }
      .MoreGameListRowTitle {
        background-color: #666;
        color: white;
      }
      .MoreGameListInRow {
        background-color: #585858;
        border-bottom: 1px solid #5f5f5f;
        color: white;
        .MoreGameListRowTitle {
          border-bottom: 1px solid #5f5f5f;
        }
        .wagerPlayRow {
          border-bottom: 1px solid #5f5f5f;
          border-left: 1px solid #5f5f5f;
        }
        .betBlockTop {
          border-left: 1px solid #5f5f5f;
        }
        .betBlockBottom {
          border-left: 1px solid #5f5f5f;
        }
      }
      .betBlock {
        //border-bottom: 1px solid #5f5f5f;
        &:hover {
          background-color: #777;
        }
      }
      .betBlockSelect {
        background-color: white;
        color: black;
      }
      .boldTableBetBlockSelect {
        background-color: white;
      }
      .menuTab {
        .active {
          background-color: #00aeff;
        }
      }
      .columnContainer {
        border-left: 1px solid #5f5f5f;
      }
      .boldBetBlockTitle,
      .boldBetBlock {
        border-bottom: 1px solid #5f5f5f;
      }
    }
  }

  #MoreGame {
    $gameWidth: 370px;
    $gameHeaderHeight: 35px;
    $gameInfoHeight: 180px;
    $gameChatHeight: 60px;
    $liveWidth: 480px;
    $liveHeight: 320px;
    $MoreGameFilterBlockHeight: 35px;

    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    width: $gameWidth;
    height: 100%;

    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }

    ::-webkit-scrollbar:vertical {
      width: 4px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background-color: rgba(0, 0, 0, 0.3);
    }

    &.playing,
    &.live,
    &.mlive {
      width: $liveWidth;

      .GameInfoBlock,
      .coming-soon {
        height: $liveHeight !important;
      }
    }

    .MoreGameHeader {
      @include nav-headrtBgcolor();

      flex-grow: 0;
      flex-shrink: 0;
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: 1fr 110px 1fr;
      position: relative;
      width: 100%;
      height: $gameHeaderHeight;

      .teamName {
        line-height: 35px;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 1rem;
        &.home {
          text-align: right;
        }
        &.away {
          text-align: left;
          padding-right: 2rem;
        }
      }
      .teamVS {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        overflow: hidden;
        color: #ffdf1b;
        font-size: 15px;
      }
      .teamVSLive {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        overflow: hidden;
        .topBlock {
          color: #c5f0c5;
          text-align: center;
        }
        .bottomBlock {
          color: white;
          text-align: center;
        }
      }
      .closeBtn {
        width: 13px;
        height: 13px;
        position: absolute;
        right: 10px;
        opacity: 0.5;
        top: 10px;
        cursor: pointer;
        &:hover {
          opacity: 1;
        }
      }

      .btn-mobile-back {
        position: absolute;
        left: 10px;
        top: 10px;
        img {
          width: 15px;
          height: auto;
          transform: rotate(90deg);
          opacity: 0.7;
          margin-right: 1rem;
          cursor: pointer;
          &:active {
            opacity: 1;
          }
        }
      }
    }

    .MoreGameBlock {
      flex-grow: 1;
      flex-shrink: 1;

      position: relative;
      width: 100%;
      max-height: calc(100% - $gameHeaderHeight);
      min-height: calc($gameInfoHeight + $MoreGameFilterBlockHeight);
      overflow-y: auto;
      z-index: 110;

      .GameInfoBlock {
        position: relative;
        width: 100%;
        height: $gameInfoHeight;

        display: flex;
        flex-direction: column;

        &.live {
          position: sticky;
          top: 0;
          z-index: 1;
        }
      }

      .leftArrowBlock {
        width: 50px;
        margin-right: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        cursor: pointer;

        i {
          font-size: 15px;
          margin-top: -2px;
        }
      }

      .MoreGameFilterBlock {
        position: relative;
        width: 100%;
        height: $MoreGameFilterBlockHeight;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        color: white;

        ::-webkit-scrollbar {
          -webkit-appearance: none;
        }

        ::-webkit-scrollbar:horizontal {
          height: 4px;
        }

        ::-webkit-scrollbar-thumb {
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.3);
        }

        .leftArrowBlock {
          flex-grow: 0;
          flex-shrink: 0;
        }

        .menuTabs {
          flex-grow: 1;
          flex-shrink: 1;

          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          gap: 12px;
          overflow-x: auto;

          .menuTab {
            position: relative;
            white-space: nowrap;
            cursor: pointer;

            .active {
              position: absolute;
              width: 100%;
              height: 2px;
              margin-top: 2px;
            }
          }
        }

        .btn-record {
          flex-grow: 0;
          flex-shrink: 0;
          margin-left: 8px;
        }
      }

      .MoreGameList {
        // overflow-y: auto;

        .MoreGameListOutRow {
          width: 100%;
          height: fit-content;
          .MoreGameListRowTitle {
            width: 100%;

            color: #000;
            height: 35px;
            cursor: pointer;

            display: flex;
            align-items: center;
          }
          .MoreGameListInRow {
            height: fit-content;
            display: flex;
            align-items: center;
            width: 100%;
            min-height: 50px;

            .wagerLabelBlock {
              width: 78px;
              height: 100%;
              display: flex;
              justify-content: center;
            }
            .wagerPlayList {
              width: calc(100% - 78px);
              &.fix {
                width: 100%;
              }

              .wagerPlayRow {
                display: flex;
                width: 100%;

                &.t116 {
                  flex-wrap: wrap;

                  .betBlock {
                    width: 33.33%;
                    border-bottom: 1px solid #eeeeee;
                  }
                }

                &:last-child {
                  border-bottom: 0px;
                }
                .betBlock {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                  cursor: pointer;

                  .betBlockTop {
                    width: 100%;
                    height: 25px;
                    padding-bottom: 2px;

                    display: flex;
                    align-items: flex-end;
                    justify-content: center;
                    cursor: pointer;
                    pointer-events: none;
                  }
                  .betBlockBottom {
                    padding-top: 2px;
                    width: 100%;
                    height: 25px;
                    text-align: center;
                    color: #3fa381;

                    cursor: pointer;
                    pointer-events: none;
                    font-weight: bold;
                  }
                }

                .columnContainer {
                  width: 33.33%;
                  border-left: 1px solid #eeeeee;
                  // border-right: 1px solid #eeeeee;
                  %boldBetBLock {
                    width: 100%;
                    height: 45px;
                    line-height: 45px;
                  }

                  .boldBetBlockTitle {
                    @extend %boldBetBLock;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-bottom: 1px solid #eeeeee;
                    // border-right: 1px solid #eeeeee;
                  }
                  .boldBetBlock {
                    @extend %boldBetBLock;
                    padding: 0 5px;
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #eeeeee;
                    // border-right: 1px solid #eeeeee;
                    cursor: pointer;
                    .boldLeft {
                      width: 40%;
                      text-align: right;
                      padding: 0 2.5px;
                      pointer-events: none;
                    }
                    .boldRight {
                      width: 60%;
                      padding: 0 2.5px;
                      text-align: center;
                      color: #3fa381;
                      pointer-events: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .GameChatBlock {
      flex-grow: 0;
      flex-shrink: 0;
      position: relative;
      width: 100%;
      max-height: calc(100% - $gameHeaderHeight - $gameInfoHeight - $MoreGameFilterBlockHeight);
      height: 60px;
      min-height: 60px;
      pointer-events: none;

      &.enable {
        height: calc((100% - $gameHeaderHeight - $gameInfoHeight - $MoreGameFilterBlockHeight) / 2);

        &.extended {
          height: calc(100% - $gameHeaderHeight - $gameInfoHeight - $MoreGameFilterBlockHeight);
        }
      }
    }

    ul.navList {
      flex-basis: 0;
      flex-grow: 0;

      position: relative;
      display: flex;
      justify-content: center;
      align-items: stretch;
      height: 35px;
      li.item {
        text-align: center;
        padding: 4px 8px;
        display: flex;
        align-items: center;

        cursor: pointer;
        img {
          opacity: 0.4;
          height: 100%;
          max-height: 30px;
        }
        &.gray {
          filter: grayscale(0.4);
          &:hover,
          &.active {
            img {
              opacity: 0.4;
            }
          }
        }

        &:hover,
        &.active {
          img {
            opacity: 1;
          }
        }
      }
    }

    .gameType2Page {
      flex-basis: 1;
      flex-grow: 1;
      position: relative;
    }

    div.coming-soon {
      flex-basis: 1;
      flex-grow: 1;
      height: 150px;
      text-align: center;
      background: #333;
      background-image: url('~@/assets/img/common/coming_soon.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      &.interactive {
        cursor: pointer;
      }
    }

    .star {
      position: absolute;
      top: 50%;
      left: 8px;
      transform: translateY(-56%);
      width: 25px;
      height: 25px;
      background: url('~@/assets/img/common/icon_star.svg') no-repeat center bottom;
      background-size: 100% auto;
      background-position: center bottom;
      margin: auto 15px auto auto;
      display: block;
      cursor: pointer;

      &:active,
      &.active {
        background-position: center top;
      }
    }
    .btn-record {
      width: 25px;
      height: 25px;
      margin-left: auto;
      margin-right: 15px;
      cursor: pointer;
    }

    // 賠率動畫
    .ani-value-up {
      &::after {
        content: '';
        position: absolute;
        right: 0;
        width: 3px;
        background: linear-gradient(transparent, red 20%, red 80%, transparent);
        height: 100%;
        animation: oddChanged 1s ease-in-out infinite;
      }
    }

    .ani-value-down {
      &::after {
        content: '';
        position: absolute;
        right: 0;
        width: 3px;
        height: 100%;
        background: linear-gradient(transparent, green 20%, green 80%, transparent);
        animation: oddChanged 1s ease-in-out infinite reverse;
      }
    }

    @keyframes oddChanged {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(-100%);
      }
    }
  }

  .live-video-iframe {
    width: 100%;
    height: 100%;
    border-width: 0;
    background-color: #000;

    &.max {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 100;
    }
  }

  .max-close {
    position: fixed;
    width: 24px;
    height: 24px;
    right: 16px;
    top: 16px;
    z-index: 101;
    cursor: pointer;
  }

  .live-video-buttons {
    position: absolute;
    right: 8px;
    top: -26px;

    > .icon-button {
      width: 20px;
      margin-left: 8px;
      transition: transform 0.6s ease;
      cursor: pointer;

      &:hover,
      &:active {
        transform: scale(1.2);
      }
    }
  }
</style>
